import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIGURATION_TOKEN } from '../app-configuration';
import { ITspPatientRepository } from './Itsp-patient.repository';
import { ApiResponse, FileCategory, PatientSettings, PatientSettingsBase, SearchPatientCaseResult, SearchPatientFilters, SearchResult } from './models';


@Injectable({ providedIn: 'root' })
export class TspPatientRepository implements ITspPatientRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);


	getSettings(patientId: string, userId: string): Observable<ApiResponse<PatientSettings>> {
		const params = new HttpParams().set('patientId', patientId).set('userId', userId);
		return this.httpClient.get<ApiResponse<PatientSettings>>(this.configs.domainTspAPI + '/api/Patient/Settings', { params });
	}

	saveSettings(patientId: string, settings: PatientSettingsBase): Observable<ApiResponse<void>> {
		const params = new HttpParams().set('patientId', patientId);
		return this.httpClient.patch<ApiResponse<void>>(this.configs.domainTspAPI + '/api/Patient/Settings', settings, { params });
	}

	search(filters: SearchPatientFilters): Observable<ApiResponse<SearchResult<SearchPatientCaseResult>>> {
		return this.httpClient.post<ApiResponse<SearchResult<SearchPatientCaseResult>>>(this.configs.domainTspAPI + '/api/Patient/Search', filters);
	}

	saveFile(patientId: string, file: File, category: FileCategory): Observable<ApiResponse<void>> {
		// const params = new HttpParams().set('patientId', patientId);
		// const formData = new FormData();
		// formData.append('file', file);
		// formData.append('category', category);
		// return this.httpClient.post<ApiResponse<void>>(this.configs.domainTspAPI + '/api/Patient/File', formData, { params });
		throw new Error('Not implemented');
	}

	deleteFile(patientId: string, category: FileCategory): Observable<ApiResponse<void>> {
		// const params = new HttpParams().set('patientId', patientId).set('category', category);
		// return this.httpClient.delete<ApiResponse<void>>(this.configs.domainTspAPI + '/api/Patient/File', { params });
		throw new Error('Not implemented');
	}

}
